import { useTranslation } from 'react-i18next';

interface FloatingFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  inputId: string;
  /** Override text direction for the input (default: 'ltr') */
  inputDir?: 'ltr' | 'rtl';
  /** Extra inline styles for the input */
  inputStyle?: React.CSSProperties;
  /** Extra class names for the input */
  inputClassName?: string;
}

export function FloatingField({
  label,
  inputId,
  inputDir = 'ltr',
  inputStyle,
  inputClassName = '',
  ...inputProps
}: FloatingFieldProps) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';

  return (
    <div className="floating-field relative">
      <input
        id={inputId}
        className={`floating-input w-full rounded-xl px-4 pt-5 pb-2 text-base outline-none transition-all ${inputClassName}`}
        style={inputStyle}
        placeholder=" "
        dir={inputDir}
        {...inputProps}
      />
      <label
        htmlFor={inputId}
        className="floating-label"
        style={{ [isRtl ? 'right' : 'left']: 16 }}
      >
        {label}
      </label>
    </div>
  );
}
